var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "BModal",
        {
          attrs: { "hide-header": "", "hide-footer": "", centered: "" },
          model: {
            value: _vm.createHabitModalVisible,
            callback: function($$v) {
              _vm.createHabitModalVisible = $$v
            },
            expression: "createHabitModalVisible"
          }
        },
        [
          _c("healthy-habits-form", {
            attrs: { inModal: "", habitDescription: _vm.title },
            on: {
              habitCreated: function(habitId) {
                return _vm.onNewHabitCreated(habitId)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("PatientPanelServiceBlock", {
        staticClass: "taller-neu-card",
        staticStyle: { cursor: "pointer" },
        attrs: {
          visible: "",
          clickOnceEnabled: false,
          id: _vm._id,
          title: _vm.title,
          description: !_vm.isFoodMicrohabitType
            ? _vm.$i18nHelpers.normalize(_vm.description)
            : null,
          action: function() {
            return _vm.onClickMicrohabitBlock()
          },
          img: _vm.img,
          backgroundImg: _vm.backgroundImage,
          actionable: _vm.isFoodMicrohabitType,
          toggleableMobileDescription: _vm.isFoodMicrohabitType
        },
        scopedSlots: _vm._u([
          {
            key: "absolute-items",
            fn: function() {
              return [
                _vm.showHeartIcon
                  ? _c("BIconHeartFill", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          value: _vm.$t(
                            "patient.microhabits.added-to-favourites",
                            {
                              habitType: _vm.microhabitI18nName({
                                plural: true
                              })
                            }
                          ),
                          expression:
                            "$t('patient.microhabits.added-to-favourites', { habitType: microhabitI18nName({ plural: true })})",
                          modifiers: { hover: true }
                        }
                      ],
                      staticClass: "position-absolute heart-microhabit",
                      attrs: { variant: "primary" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.deletePatientMicrohabit.apply(
                            null,
                            arguments
                          )
                        }
                      }
                    })
                  : _vm._e()
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c("span", { staticClass: "d-block mt-3" }, [
                  _c(
                    "span",
                    { staticClass: "d-block secondary-badges" },
                    [
                      _vm.patientMicrohabit.achieved
                        ? _c(
                            "b-badge",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  value: _vm.achievedTooltipText,
                                  expression: "achievedTooltipText",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass: "d-inline-block",
                              attrs: { variant: "success" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.setMicrohabitAchievementStatus(
                                    false
                                  )
                                }
                              }
                            },
                            [_vm._v("✔ " + _vm._s(_vm.achievedBadgeText))]
                          )
                        : _c(
                            "b-badge",
                            {
                              staticClass: "d-inline-block",
                              attrs: { variant: "info" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.setMicrohabitAchievementStatus(
                                    true
                                  )
                                }
                              }
                            },
                            [
                              _c("BIconPlusCircle"),
                              _vm._v(" " + _vm._s(_vm.notAchievedBadgeText))
                            ],
                            1
                          ),
                      _vm._v(" "),
                      _vm.patientMicrohabit.habitId
                        ? _c(
                            "b-badge",
                            {
                              staticClass: "d-inline-block",
                              attrs: { variant: "primary" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.$helpers.goToHabits()
                                }
                              }
                            },
                            [
                              _c("BIconBellFill", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    value: _vm.$t(
                                      "patient.microhabits.reminder"
                                    ),
                                    expression:
                                      "$t('patient.microhabits.reminder')",
                                    modifiers: { hover: true }
                                  }
                                ]
                              })
                            ],
                            1
                          )
                        : _c(
                            "b-badge",
                            {
                              staticClass: "d-inline-block",
                              attrs: { variant: "primary" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return function() {
                                    _vm.createHabitModalVisible = true
                                  }.apply(null, arguments)
                                }
                              }
                            },
                            [
                              _c("BIconBell", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    value: _vm.$t(
                                      "patient.microhabits.create-habit"
                                    ),
                                    expression:
                                      "$t('patient.microhabits.create-habit')",
                                    modifiers: { hover: true }
                                  }
                                ]
                              })
                            ],
                            1
                          )
                    ],
                    1
                  )
                ])
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5afa95f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5afa95f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/microhabits/PatientMicrohabitBlock.vue
// module id = 2726
// module chunks = 61 62 64 65